var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-wrapper o-wrapper--huge c-wrapper"},[_c('vue-progress-bar'),_c('router-view',{staticClass:"c-wrapper--min-100vh"}),_c('modalSimple')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }